<template>
	<Modal id="create-offer-modal">
		<template #title>{{ trans('events.bundles.offers.create') }}</template>
		<div class="grid grid-cols-1 lg:grid-cols-2 w-full gap-3">
			<LabeledObject required class="lg:col-span-2">
				<template #label>{{ trans('general.title') }}</template>
				<input v-model="form.title" type="text">
			</LabeledObject>
			<div class="lg:col-span-2 flex items-end gap-3">
				<LabeledObject full>
					<template #label>{{ trans('events.bundles.offers.maximum') }}</template>
					<IconNumberInput v-model="form.maximum" :min="0" :step="1" icon-class="fa-solid fa-ticket" full/>
				</LabeledObject>
				<Switch v-model.number="form.active" :label="trans('events.bundles.offers.active')"/>
			</div>
		</div>
		<template #footer>
			<PrimaryButton :color="Color.Green" @click.stop="create">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('general.confirm') }}
			</PrimaryButton>
		</template>
	</Modal>
	<div class="p-8 rounded-lg border-2 border-dashed border-gray-400 hover:border-green-400 dark:hover:border-green-600 text-gray-400 hover:text-green-400 dark:hover:text-green-600 hover:bg-green-50/30 dark:hover:bg-green-950/30 flex flex-col items-center justify-center cursor-pointer gap-2" @click.stop="showModal('create-offer-modal')">
		<i class="fa-solid fa-plus text-2xl"/>
		<p>{{ trans('events.bundles.offers.create') }}</p>
	</div>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {ref, type Ref, defineProps} from 'vue'
import type {Event} from '@/Types/Events/Event'
import Modal from '@/Components/UI/Modals/Modal.vue'
import Switch from '@/Components/UI/Switches/Switch.vue'
import {type InertiaForm, useForm} from '@inertiajs/vue3'
import {type Bundle} from '@/Types/Events/Bundles/Bundle'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Offer} from '@/Types/Events/Bundles/Offers/Offer'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import IconNumberInput from '@/Components/UI/Inputs/IconNumberInput.vue'
import {showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	bundle:Bundle,
	event:Event,
}>()

const bundle:Ref<Bundle> = ref(props.bundle)
const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const form:InertiaForm<Partial<Offer>> = useForm<Partial<Offer>>({
	title: '',
	description: '',
	maximum: 0,
	active: false,
})

function create():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		form.post(route('events.bundles.offers.store', {
			event: event.value.id,
			bundle: bundle.value.id,
		}), {
			onSuccess: () => {
				showSuccess(trans('general.inserted'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
				form.reset()
			}
		})
	}
}
</script>